export interface IWorkspaceProjectRole {
  id: string;
  enumId: EWorkspaceProjectRole;
  name: string;
}

export enum EWorkspaceProjectRole {
  ProjectOwner = 1,
  Developer = 2,
  Designer = 3,
  Viewer = 4
}
